module.exports = __webpack_public_path__ + "img/objective-5.5a76a83e.jpg";